import {Component, EventEmitter, Output, NgZone, Input, ChangeDetectionStrategy} from '@angular/core';
import {ComponentAsElement} from "../../services/common/bootstrap/annotation/component-as-element";
import {iSelectedPPoint} from "../../model/CartModel";
import {CartService} from "../../services/cart.service";

@ComponentAsElement('v-cart-poczta-polska-element')
@Component({
  selector: 'v-cart-poczta-polska',
  templateUrl: './cart-poczta-polska.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CartPocztaPolskaComponent {
  @Input() widget: boolean;
  @Input() error: boolean;
  @Input('point') selectedPP: iSelectedPPoint;
  @Input() selectedPPType: string;
  @Input() PPType: string;
  @Output() defineNewPoint: EventEmitter<void> = new EventEmitter();
  showDetails = false;

  constructor() { }

  ngOnChanges() {
    this.selectedPP && this.PPType === this.selectedPPType ? this.showDetails = true : this.showDetails = false;
  }

  newPPPoint() {
    this.defineNewPoint.emit();
  }
}
